export default __webpack_public_path__ + "static/media/banner425.1600f50f.webp";